export default __webpack_public_path__ + "static/media/mobile_bg.05dcf862.jpg";